export const VIRTUAL_VISIT_ID = 'VirtualVisitID';
export const VIRTUAL_VISIT_LABEL = 'Virtual Video Visit';
